import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Newsletter from "@/components/feature/Newsletter";
import SEOSchema from "@/components/feature/SEOSchema";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedComics from "./components/FeaturedComics";
import LatestComics from "./components/LatestComics";
import Testimonials from "./components/Testimonials";
import { siteConfig } from "@/mocks/comics";
import { Link } from "react-router-dom";

const articleCovers: Record<string, string> = {
  "article-01": "https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20style%20illustration%20in%20landscape%20format%20of%20a%20powerful%20shadow%20army%20rising%20behind%20a%20lone%20warrior%20silhouette%2C%20dramatic%20contrast%20between%20black%20shadows%20and%20purple%20energy%2C%20dark%20atmospheric%20backdrop%2C%20cinematic%20wide%20composition%2C%20webtoon%20aesthetic&width=800&height=450&seq=article-01&orientation=landscape",
  "article-02": "https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20style%20illustration%20in%20landscape%20format%20of%20multiple%20couples%20in%20different%20settings%20like%20cherry%20blossom%20path%2C%20coffee%20shop%2C%20and%20starry%20night%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20webtoon%20aesthetic&width=800&height=450&seq=article-02&orientation=landscape",
  "article-03": "https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20illustration%20in%20landscape%20format%20showing%20the%20evolution%20of%20art%20styles%20from%20traditional%20ink%20drawing%20to%20modern%20digital%20webtoon%2C%20split%20composition%20with%20left%20side%20classic%20style%20and%20right%20side%20vibrant%20digital%20colors%2C%20clean%20aesthetic&width=800&height=450&seq=article-03&orientation=landscape",
};

const homeArticles = [
  {
    id: 1,
    slug: "solo-leveling-review",
    title: "《我独自升级》完结评测：一部重新定义韩漫天花板的神作",
    excerpt: "从E级到最强，成振宇的升级之路不仅震撼了漫画界，更在全球范围内掀起了一场韩漫热潮。本文深度解析这部现象级作品的成功密码。",
    category: "热血动作",
    coverSeq: "article-01",
    date: "2024-06-15",
    readTime: "8分钟",
    views: "12,560",
  },
  {
    id: 2,
    slug: "romance-manhwa-recommend",
    title: "2024年必看的10部韩国恋爱漫画推荐",
    excerpt: "从校园纯爱到宫廷虐恋，我们为你精心挑选了10部2024年最值得追的韩国恋爱漫画，每一部都能让你心动不已。",
    category: "恋爱甜漫",
    coverSeq: "article-02",
    date: "2024-05-20",
    readTime: "12分钟",
    views: "18,230",
  },
  {
    id: 3,
    slug: "manhwa-art-style-guide",
    title: "韩国漫画画风演变史：从传统到数字时代的视觉革命",
    excerpt: "韩漫画风经历了从模仿日漫到形成独特风格的过程，如今已成为全球漫画界不可忽视的视觉力量。",
    category: "行业观察",
    coverSeq: "article-03",
    date: "2024-04-10",
    readTime: "15分钟",
    views: "9,870",
  },
];

export default function Home() {
  return (
    <>
      <SEOSchema
        type="WebSite"
        pageUrl="/"
        pageTitle={`${siteConfig.name} - ${siteConfig.tagline}`}
        pageDescription={siteConfig.description}
      />

      <Navbar />

      <main>
        <Hero />

        <CategoryGrid />

        <FeaturedComics />

        <LatestComics />

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
              <div>
                <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 text-xs font-semibold text-secondary-600 bg-secondary-50/50 whitespace-nowrap">
                  深度阅读
                </span>
                <h2 className="mt-4 text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
                  最新漫评与推荐
                </h2>
                <p className="mt-3 text-sm md:text-base text-foreground-500">
                  专业编辑团队为你精选解读
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {homeArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/comic/${article.slug}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="aspect-[16/9] overflow-hidden">
                    <img
                      src={articleCovers[article.coverSeq]}
                      alt={article.title}
                      title={`${article.title} - 韩漫屋深度评测`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-medium whitespace-nowrap">
                        {article.category}
                      </span>
                      <span>{article.date}</span>
                      <span>{article.readTime}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-bold font-heading text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="mt-4 flex items-center justify-between">
                      <span className="text-xs text-foreground-400">
                        {article.views} 阅读
                      </span>
                      <span className="text-xs text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all whitespace-nowrap">
                        阅读全文 <i className="ri-arrow-right-line" />
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <Testimonials />

        <Newsletter />
      </main>

      <Footer />
    </>
  );
}
